import React from 'react';
import {Col} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';

class NavTab extends AbstractComponent {   
    constructor(props) {
        super(props);

        this.state = {
            active: 0
        }
    } 

    onTabClick(i) {
        this.setState({active: i});        
    }    

    visible(item) {
        const propsItem = item.props !== undefined ? item.props : {};
        const visible = propsItem.visible !== undefined ? propsItem.visible : true

        if(visible)
            return "";
            
        return "display-none";
    }    

    render() {
        return( 
            <Col md={this.props.md} 
                 xs={this.props.xs} 
                 sm={this.props.sm} 
                 lg={this.props.lg}>
                <section id={this.props.idTab}>
                    <ul 
                        className="nav nav-tabs"
                        role="tablist"
                    >                                
                        {this.props.nav.map((item, i) => {                                                        
                            return ( 
                                <li 
                                    role="presentation" 
                                    className={"nav-item " + this.visible(item) + " " + (this.state.active === i ? "active" : "")} 
                                    key={i}
                                    data-target={"#" + item.tabName}
                                    onClick={() => this.onTabClick(i)}>
                                    <a>
                                        {item.descricao}
                                        
                                        <span className={(this.props.indexErro[i].erro ? '' : 'display-none')}>
                                            &nbsp;&nbsp;
                                            <i className="fas fa-exclamation-triangle" style={{color: 'red'}}></i>
                                        </span>
                                    </a>                                    
                                </li>
                            )                        
                        })}                  
                    </ul>

                    <div className="tab-content">
                        {this.props.nav.map((item, i) => {                                                        
                            const Component = item.component;
                            const propsItem = item.props !== undefined ? item.props : {};

                            return ( 
                                <section 
                                    key={i}
                                    id={item.tabName}
                                    className={"clearfix tab-pane " + (this.state.active === i ? "active" : "")}
                                >
                                    <Component                                        
                                        {...propsItem}                                      
                                    />                                     
                                </section>                            
                            )                                            
                        })}                         
                    </div>
                </section>
            </Col>            
        )
    }
}

NavTab.defaultProps = {
    md: 12,
    xs: 12,
    sm: 12,
    lg: 12,
    idTab: 'tabs'
}

export default NavTab;